/* @flow */
import * as React from "react";
import type Phone from "nexia_mobile/models/phone";
import { IconUserBrowser, IconUserMobile } from "nx-components/Icons";
import type { StylesObject } from "nx-components/utils/prefixStyles";

type Props = {
  phone: Phone,
  style: StylesObject,
};

export default class UserIcon extends React.Component<Props> {
  render() {
    const { phone, style } = this.props;
    const platform = phone.get("platform");

    let icon;
    if (/^(android|ip(hone|ad|od)|windows)/i.test(platform)) {
      icon = <IconUserMobile style={style} />;
    } else {
      icon = <IconUserBrowser style={style} />;
    }

    return icon;
  }
}



// WEBPACK FOOTER //
// ./src/components/UserIcon.jsx